import styles from './AssistantMessage.module.css';

interface AssistantMessageProps {
  text: string;
}

export function AssistantMessage({ text }: AssistantMessageProps) {
  const renderText = (raw: string) => {
    const segments = raw.split(/(\*\*.*?\*\*)/g);
    return (
      <>
        {segments.map((segment, index) => {
          if (segment.startsWith('**') && segment.endsWith('**')) {
            const inner = segment.slice(2, -2);
            return <strong key={index}>{inner}</strong>;
          }
          return <span key={index}>{segment}</span>;
        })}
      </>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 2a7 7 0 0 1 7 7v2.5a1.5 1.5 0 0 1 0 3V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-4.5a1.5 1.5 0 0 1 0-3V9a7 7 0 0 1 7-7z" />
          <path d="M9 13h6" />
          <path d="M9 17h6" />
          <circle cx="9" cy="9" r="1" fill="currentColor" stroke="none" />
          <circle cx="15" cy="9" r="1" fill="currentColor" stroke="none" />
        </svg>
      </div>
      <div className={styles.bubble}>{renderText(text)}</div>
    </div>
  );
}
